<template>
	<div class="ssh" :style="{height: layout.height}">
		<widget_terminal ref="ref_terminal" :bottom="layout.bottom" :height="layout.height"
		                 :width="layout.width"></widget_terminal>
	</div>
</template>

<script>
	import widget_terminal from './widgets/terminal';
	import {CreateWebsocket} from "../../apilist/websocket";

	export default {
		name: "ssh",
		data(){
			return {
				ternimal_socket: null,
				layout: {
					height: '0px',
					bottom: '0px',
					width: "0px",
				}
			}
		},
		methods: {
			resizeWindow(){
				this.layout.width = window.innerWidth + "px";
				this.layout.height = (window.innerHeight - window.layout.header_height) + 'px';
			},
			onChange(data){
				// @todo Storage 存储
			},
			StartWS(){
				let that = this;
				let ws = CreateWebsocket("/service/run");
				ws.binaryType = "arraybuffer";
				ws.onmessage = function(evt){
					let data = new TextDecoder().decode(evt.data);
					let recv_data = JSON.parse(data);
					let message_type = recv_data.type;
					if(message_type === "data"){
						that.$refs.ref_terminal.write(recv_data.message);
					}else if(message_type === "error"){
						that.$refs.ref_terminal.sayError(recv_data.message);
					}else if(message_type === "busy"){
						that.$refs.ref_terminal.sayHigh(recv_data.message);
					}else if(message_type === "fatal"){
						that.$refs.ref_terminal.sayHigh(recv_data.message);
					}else{
						that.$refs.ref_terminal.sayError("error: Unable to parse the data");
					}
				};

				ws.onclose = function(evt){
					that.socket_ended_at = Date.now();
					let cost_time = that.socket_ended_at - that.socket_started_at;
					that.$refs.ref_terminal.sayExit("terminal exited (" + cost_time + " ms)");
					ws.close();
				};

				ws.onerror = function(err){
					if(ws.readyState === 3){
						that.$refs.ref_terminal.sayError("error: cannot connect run code server.");
					}
				};

				ws.onopen = function(){
					that.ternimal_socket = ws;
					let data = {
						language: "ssh",
						code: "uuid",
					};
					ws.send(JSON.stringify(data));
					that.socket_started_at = Date.now();
				};

				this.ternimal_socket = ws;
			},
		},
		components: {
			widget_terminal,
		},
		watch: {
			text_data(value){
				this.$refs.markdown.setMdValueFn(value);
			},
		},
		mounted(){
			let that = this;
			this.resizeWindow();
			this.$refs.ref_terminal.resizeTerminal();

			this.$nextTick(()=>{
				that.resizeWindow();
				that.$refs.ref_terminal.resizeTerminal();

				$(window).resize(function(){
					that.resizeWindow();
					that.$refs.ref_terminal.resizeTerminal();
				});
			});

			this.$on('terminal-update', function(data){
				if(that.ternimal_socket !== null && that.ternimal_socket.readyState === 1){
					let send_data = {
						type: "data",
						message: data,
					};
					send_data = JSON.stringify(send_data);
					that.ternimal_socket.send(send_data);
				}
			});

			this.$on('terminal-resize', function(data){
				if(that.ternimal_socket !== null && that.ternimal_socket.readyState === 1){
					let send_data = {
						type: "resize",
						message: data.cols + "|" + data.rows,
					};
					send_data = JSON.stringify(send_data);
					that.ternimal_socket.send(send_data);
				}
			});
		},
		created(){
			this.StartWS();
		},
		destroyed(){
			this.ternimal_socket.close();
		}
	}
</script>

<style scoped lang="less">
	.ssh {
		background: #000;
	}
</style>
